import { defineStore } from "pinia";
import { useToast } from "vue-toastification";

/**
 * Thin shim that preserves the original `useToastStore` API
 * (`success` / `error` / `info` / `warning` / `dismiss`) while delegating to
 * vue-toastification under the hood, so the ~existing `toast.success(...)`
 * call sites across views work unchanged.
 */
export const useToastStore = defineStore("toast", () => {
  const t = useToast();

  return {
    success: (msg) => t.success(msg),
    error:   (msg) => t.error(msg),
    warning: (msg) => t.warning(msg),
    info:    (msg) => t.info(msg),
    dismiss: () => t.clear(),
  };
});
